import { jwtDecode } from "jwt-decode";
import { Navigate, Outlet } from "react-router-dom";
type propsGuard = { children?: any };

export const InternarGuard = ({ children }: propsGuard) => {
  const userToken = localStorage.getItem("auth_token");
  if (userToken) {
    try {
      jwtDecode(userToken);
    } catch (error) {
      <Navigate to="/home/view-login-private" replace />;
    }
  } else {
    return <Navigate to="/home/view-login-private" replace />;
  }

  return children ? children : <Outlet />;
};
